export default {
  presenter: 'barinka',
  title: 'Bash a strukturované programování',
  subtitle: 'mírně pokročilí',
  text: `
Přednáška se bude zabývat zoufalými situacemi, kdy potřebujete přehledně programovat v prostředí bash.
Pro psaní přehlednějšího kódu jsou k dispozici skripty, aliasy a funkce. Pro psaní nepřehlednějšího
kódu pak příkaz eval (evil?). Těmto konstrukcím a jejich použití bude věnována tato přednáška.
Pokročilí uživatelé se dozví, jak se vypořádat s neexistencí výstupní hodnoty funkce nebo s parametry
volanými odkazem.
  `,
}



// WEBPACK FOOTER //
// ./src/content/installfest/data/presentations/barinka-bash.js